// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";

const ProtectedRoute = ({ element }) => {
  const isAuthenticated = useIsAuthenticated();
  return isAuthenticated||sessionStorage.getItem('token') ? element : <Navigate to="/" />;
};

export default ProtectedRoute;
